import PageShell from "./PageShell";
import Journal from "@/components/site/Journal";

export default function JournalPage() {
  return (
    <PageShell testId="page-journal">
      <Journal />
    </PageShell>
  );
}
